import React from "react";
import { Box, Button, Flex, HStack, Tag, Text, VStack } from "@chakra-ui/react";
import {
  CalendarBlank,
  CircleHalf,
  Clock,
  ListBullets,
  PencilSimple,
  Stack as StackIcon,
  Tag as TagIcon,
  TreeStructure,
  User,
} from "@phosphor-icons/react";
import { COMPANY_WIDE, TASK_DATA_TYPE_CONFIG, TASK_STATUSES } from "../../suppliersMock";

const STATUS_BAR = {
  [TASK_STATUSES.NOT_STARTED]: { progress: 12, color: "#FC8181", label: "Not started" },
  [TASK_STATUSES.IN_PROGRESS]: { progress: 50, color: "#FBD38D", label: "In progress" },
  [TASK_STATUSES.COMPLETE]:    { progress: 100, color: "#B8E086", label: "Complete" },
};

const Row = ({ icon: Icon, label, children }) => (
  <Flex align="flex-start" gap={3} py={3}>
    <Box color="gray.400" mt={0.5} flexShrink={0}><Icon size={18} /></Box>
    <Text fontSize="14px" color="gray.600" minW="92px" flexShrink={0}>{label}</Text>
    <Box flex={1}>{children}</Box>
  </Flex>
);

const Pill = ({ children }) => (
  <Tag bg="#FFF8E1" color="gray.700" borderRadius="md" px={2.5} py={1} fontSize="12px" fontWeight="600" textTransform="uppercase">
    {children}
  </Tag>
);

// Content for the Task Details right-hand tray (rendered inside the platform's
// RightSidebar — the tray chrome/header is supplied by RightSidebarWidget).
function TaskManagePanel({ supplier, task, onEdit }) {
  const statusCfg = STATUS_BAR[task.status] || STATUS_BAR[TASK_STATUSES.NOT_STARTED];
  const typeCfg = TASK_DATA_TYPE_CONFIG[task.dataType] || {};

  return (
    <Box bg="white" borderRadius="md" m={2} px={5} py={4}>
      <Text fontSize="16px" fontWeight="700" color="darkTeal" borderBottom="2px solid" borderColor="lime" display="inline-block" pb={1} mb={4}>
        Manage
      </Text>

      <VStack align="stretch" spacing={0} divider={<Box borderBottom="1px solid" borderColor="gray.100" />}>
        <Row icon={CircleHalf} label="Status">
          <Text fontSize="14px" color="gray.700" fontWeight="600" mb={1}>{statusCfg.label}</Text>
          <Box h="8px" borderRadius="full" bg="gray.100" overflow="hidden">
            <Box h="100%" w={`${statusCfg.progress}%`} borderRadius="full" bg={statusCfg.color} />
          </Box>
        </Row>
        <Row icon={User} label="Assignee"><Pill>{task.assignee}</Pill></Row>
        <Row icon={CalendarBlank} label="Period">
          <Text fontSize="14px" color="gray.700">{task.year} – {task.quarter}</Text>
        </Row>
        <Row icon={StackIcon} label="Data type">
          <HStack spacing={1.5}>
            <Box w="9px" h="9px" borderRadius="full" bg={typeCfg.text || "gray.400"} />
            <Text fontSize="14px" color="gray.700">{task.dataType}</Text>
          </HStack>
        </Row>
        <Row icon={TreeStructure} label="Division">
          <Text fontSize="14px" color="gray.700">{task.division || COMPANY_WIDE}</Text>
        </Row>
        <Row icon={TagIcon} label="Category">
          <Text fontSize="14px" color="gray.700">{supplier.category}</Text>
        </Row>
        <Row icon={ListBullets} label="Last edit"><Pill>{task.assignee}</Pill></Row>
        <Row icon={Clock} label="Edit date">
          <Text fontSize="14px" color="gray.700">—</Text>
        </Row>
      </VStack>

      <Button
        mt={5}
        w="100%"
        variant="secondary"
        borderRadius="md"
        leftIcon={<PencilSimple size={16} />}
        onClick={onEdit}
      >
        Edit task
      </Button>
    </Box>
  );
}

export default TaskManagePanel;
